export default __webpack_public_path__ + "static/B0175-54ecadae942eac9e7ace90c553143305.png";